import Model from './model.js'
import {RequestinProcess} from '../../helper/request.action.js'
import UserHelper from '../../helper/user.js'
import MessageProperties from '../../config/message.js'
// Import Toast src: https://fkhadra.github.io/react-toastify/
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
export default {
  RegisterAsset:function(params){
      if(!UserHelper.HasPermission(params.permission_needed,params.UserReducer)){
        toast.error(MessageProperties.PERMISSION.DONT_HAVE_ACCESS)
        return
      }
      params.RunRedux(RequestinProcess({in_process:true,type:"REGISTER"}))
      Model.Register(params)
  },
  UpdateAsset:function(params){
      params.RunRedux(RequestinProcess({in_process:true,type:"UPDATE"}))
      Model.Update(params)
  },
  DeleteAsset:function(params){
      if(!UserHelper.HasPermission(params.permission_needed,params.UserReducer)){
        toast.error(MessageProperties.PERMISSION.DONT_HAVE_ACCESS)
        return
      }
      params.RunRedux(RequestinProcess({in_process:true,type:"DELETE"}))
      Model.Delete(params)
  },
  ReadAsset:function(params){
      if(params.action === 'Next'){
        params.data.url = params.Reducer.next
      }else if(params.action === 'Previous'){
        params.data.url = params.Reducer.previous
      }
      params.RunRedux(RequestinProcess({in_process:true,type:"READ"}))
      Model.Read(params)
  },
  ReadAssetAsMaster:function(params){
      params.RunRedux(RequestinProcess({in_process:true,type:"READ"}))
      Model.ReadAsMaster(params)
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/presenter.js